import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3.5),
    width: `calc(100vw - 72px)`,
    minHeight: "100vh",
    backgroundColor: "#fafafa",
    borderTopLeftRadius: 20,
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      padding: theme.spacing(2),
      borderTopLeftRadius: 0,
    },
  },
  contentShift: {
    width: `calc(100vw - 240px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    ...theme.mixins.toolbar,
  },
  link: {
    '&:not(:first-child)': {
      paddingLeft: 15
    }
  }
}));
